import { IconBook } from 'featherico';
import PropTypes from 'prop-types';
import * as React from 'react';
import Link from '../Link';

export type DocumentationLinkProps = {
    href: string;
    title: string;
    text?: React.ReactNode;
};

function DocumentationLink({ href, title, text }: DocumentationLinkProps) {
    return (
        <Link openInNewTab={true} href={href} title={title} className="documentation-link button">
            <IconBook />
            {text || ' Documentation'}
        </Link>
    );
}

DocumentationLink.propTypes = {
    href: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
};

export default DocumentationLink;
